
class Tabs {
  constructor() {
    if ($('.tabs-component').length > 0) {
      this.onSwitchTabs();
    }
  }
  onSwitchTabs() {
    $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
      e.preventDefault();
      let nowActiveTab = e.target,
        previousActiveTab = e.relatedTarget;

      $(nowActiveTab).attr({
        'aria-selected': 'true'
      });
      $(previousActiveTab).attr({
        'aria-selected': 'false'
      });
      // Extract the hash value (e.g., #week-2) and update carousel
      const activeTabHash = nowActiveTab.hash;
      this.updateCarouselPosition(activeTabHash);
    });
  }

  updateCarouselPosition(activeTabHash) {
    if (activeTabHash) {
      // Handle MPC carousels
      const mpcCarouselSelector = `${activeTabHash} .mpc-slick-carousel`;
      if ($(mpcCarouselSelector).length > 0) {
        $(mpcCarouselSelector).slick('setPosition');
      }
      // Handle cards carousels (textofferslist)
      const cardsCarouselSelector = `${activeTabHash} .text-offers-component .slick-carousel`;
      if ($(cardsCarouselSelector).length > 0) {
        $(cardsCarouselSelector).slick('setPosition');
      }

      // Handle hotel deals carousels
      const hotelDealsCarouselSelector = `${activeTabHash} .hotel-deals-slider`;
      if ($(hotelDealsCarouselSelector).length > 0) {
        $(hotelDealsCarouselSelector).slick('setPosition');
      }
    }
  }
}

export default new Tabs();
